<template>
  <div class="base-honeycomb">
    <div :class="{ honey_area: true, border: viewStatus != 2 }">
      <!-- 按钮 -->
      <div class="honey-list">
        <div
          class="prize-item prize-btn"
          :style="{
            backgroundImage: `url(${mValue.drawBtn || defaultBtn})`
          }"
          @click="onStart"
        ></div>
        <!-- 奖品项 -->
        <ul class="prize-box">
          <li
            class="prize-item prize-item__box"
            v-for="(item, index) in listValue"
            :key="index"
            :class="listValue.length > 6 ? 'max' : 'min'"
            :style="{
              backgroundImage: `url(${
                index == listIndex
                  ? mValue.drawActive || defaultAni
                  : mValue.prizeBg || defaultBg
              })`
            }"
          >
            <div
              class="prize-item prize"
              :style="{
                backgroundImage: `url(${item.prizeImg})`
              }"
            ></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseHoneycomb',
  props: {
    prizeList: {
      required: true
    },
    draw: {
      type: Object,
      default: () => {}
    },
    turnsTime: {
      // 转动需要持续的时间(秒)
      default: 3
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      mValue: undefined,
      listValue: [],
      defaultBtn:
        '//cdn-tx-admin-test.3kwan.com/2023/07/19/02bf631ad05481d6c1330db2935fc1fc.png',
      defaultBg:
        '//cdn-tx-admin-test.3kwan.com/2023/07/19/95b9217d56bcc364b0b94621d0734d95.png',
      defaultAni:
        '//cdn-tx-admin-test.3kwan.com/2023/07/19/0a73a73d7c9cd1fcb8ac433181b4e2cb.png',
      listIndex: -1, //当前走到的index
      baseSpeed: 300,
      speed: 20,

      hasCircleTimes: 0,
      hasMoveTimes: 0,
      luckyIndex: 0,
      circleTimes: 3
    };
  },
  computed: {
    state() {
      return this.$store.state;
    }
  },
  watch: {
    draw: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.mValue = newVal;
      }
    },
    prizeList: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.listValue = newVal;
        console.log(oldVal);
      }
    }
  },
  methods: {
    onStart() {
      this.$emit('start-turns');
    },
    runAni(index) {
      this.luckyIndex = index;
      this.start(this.baseSpeed); //开始动画
    },
    start(speed) {
      if (this.hasMoveTimes < 5) speed -= this.speed + this.hasMoveTimes * 10;
      else if (this.hasMoveTimes > this.circleTimes * 8 - 7)
        speed += this.speed + (this.circleTimes * 8 - this.hasMoveTimes) * 10;
      let timer = setTimeout(() => {
        if (this.hasCircleTimes !== -1) {
          //如果没转完定义好的圈圈次数，继续转圈圈
          if (this.listIndex < this.listValue.length - 1) {
            this.listIndex += 1;
          } else {
            this.listIndex = 0;
            this.hasCircleTimes++;
          }
          if (this.hasCircleTimes >= this.circleTimes) {
            //是否转了circleTimes次
            this.hasCircleTimes = -1; //转圈圈结束
          }
          this.hasMoveTimes++; //记录跳动了多少次
          this.start(speed); //递归
        } else {
          //转圈次数已经达到
          if (this.listIndex < this.luckyIndex) {
            //如果当前cur位置没到中奖位置，继续跳
            this.listIndex += 1; //跳下一个
            this.hasMoveTimes++; //记录跳动次数
            this.start(speed); //递归
          } else {
            //cur位置到达中奖位置，停止
            clearTimeout(timer);
            this.hasMoveTimes = 0;
            this.hasCircleTimes = 0;
            this.$emit('end-turns');
          }
        }
      }, speed);
    }
  }
};
</script>

<style lang="scss" scoped>
.honey_area {
  position: relative;
  width: 100%;
  height: 100%;
}
.prize-item {
  width: 155px;
  height: 132px;
  background-size: cover;
  background-repeat: no-repeat;
}
.prize-item__box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.prize {
  width: 90px;
  height: 90px;
  background-size: cover;
  background-repeat: no-repeat;
}
.prize-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
// .border {
//   border: 2px solid red;
// }
.prize-box {
  li {
    position: absolute;
  }
  .max:nth-child(8n + 1) {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .max:nth-child(8n + 2) {
    left: 125px;
    top: 70px;
  }
  .max:nth-child(8n + 3) {
    left: 250px;
    top: 0px;
  }
  .max:nth-child(8n + 4) {
    left: 375px;
    top: 70px;
  }
  .max:nth-child(8n + 5) {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .max:nth-child(8n + 6) {
    left: 377px;
    top: 210px;
  }
  .max:nth-child(8n + 7) {
    left: 250px;
    bottom: 0;
  }
  .max:nth-child(8n + 8) {
    left: 125px;
    top: 210px;
  }

  .min:nth-child(1) {
    left: 125px;
    top: 70px;
  }
  .min:nth-child(2) {
    left: 250px;
    top: 0px;
  }
  .min:nth-child(3) {
    left: 377px;
    top: 70px;
  }
  .min:nth-child(4) {
    left: 375px;
    top: 210px;
  }
  .min:nth-child(5) {
    left: 250px;
    bottom: 0;
  }
  .min:nth-child(6) {
    left: 125px;
    top: 210px;
  }
}
</style>
